import { AxiosResponse } from 'axios';
import { IBaseApiRequest } from '@api';
import {
  IDirectoryItemsFilters,
  IPaginated,
  PaginationMeta,
  ICountry,
} from '@entities';
import { getSorterParamsForApi, insertIfObj } from '@functions';

interface IGetAll extends IBaseApiRequest, IDirectoryItemsFilters, IPaginated {
  countryKind?: string;
  attribute?: string;
  direction?: string;
}
export async function getAll({
  api,
  countryKind,
  offset,
  limit,
  attribute,
  direction,
}: IGetAll) {
  let params = {
    ...getSorterParamsForApi({ attribute, direction }),
    ...getSorterParamsForApi({ attribute, direction }),
    ...insertIfObj(Boolean(countryKind), {
      countryKind: countryKind,
    }),
    offset,
    limit,
  };

  let response = (await api.get('v1/countries', {
    params,
  })) as AxiosResponse<{
    data: { data: ICountry[] };
    meta: PaginationMeta;
  }>;

  return response.data.data.data;
}
